export enum FilterKey {
  Price = 'price',
  Rating = 'rating',
  Rate = 'rate',
}
